import { createMutationHelper } from '@utils/swr'
import { type OrderActionSettingRequest } from '../types/apiRequest'
import { type OrderActionSettingResponse } from '../types/apiResponse'
import { type WpApis } from '../types/apis'

const { useMutation } = createMutationHelper<WpApis['get']['orderActionsSetting'], OrderActionSettingResponse, OrderActionSettingRequest>({
  client: 'wpRelay',
  key: '/wp-json/lds/users/:userId/orders/:orderId/nonce',
  fetcher: (_url, { client, arg }) => client.get(`/wp-json/lds/users/${arg.user_id}/orders/${arg.order_id}/nonce?type=${arg.type}`),
})

export const useApiOrderActionSetting = useMutation
